import React from 'react';
import LocationTemplate from './LocationTemplate';

const CentervillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Centerville"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27560"]}
      latitude={35.7876}
      longitude={-78.6234}
      population={1456}
      historicalFact="Small community near Raleigh, named for its central location in the county."
      nearbyTowns={[
        "Raleigh, NC",
        "Wake Forest, NC",
        "Rolesville, NC",
        "Knightdale, NC",
        "Wendell, NC",
        "Zebulon, NC",
        "Youngsville, NC",
        "Louisburg, NC"
      ]}
    />
  );
};

export default CentervillePage;